/** A command sent from the client to the server. */
export enum ClientCommand {
  tableStart = "tableStart",
  getGameInfo1 = "getGameInfo1",
  getGameInfo2 = "getGameInfo2",
  loaded = "loaded",
  action = "action",
  pause = "pause",
  note = "note",
  tag = "tag",
  tagDelete = "tagDelete",
  tagsDeleteAll = "tagsDeleteAll",
  tableUnattend = "tableUnattend",
  tableSpectate = "tableSpectate",
  replayAction = "replayAction",
  replayCreate = "replayCreate",
  tableRestart = "tableRestart",
  tableSuggest = "tableSuggest",
  chat = "chat",
  chatRead = "chatRead",
  chatTyping = "chatTyping",
  tagSearch = "tagSearch",
  chatFriend = "chatFriend",
  chatLink = "chatLink",
  chatLinked = "chatLinked",
  chatPlayerInfo = "chatPlayerInfo",
  chatPM = "chatPM",
  chatPMHistoryGet = "chatPMHistoryGet",
  chatUnfriend = "chatUnfriend",
  chatUnlink = "chatUnlink",
  getName = "getName",
  historyFriendsGet = "historyFriendsGet",
  historyGet = "historyGet",
  historyGetSeed = "historyGetSeed",
  inactive = "inactive",
  setting = "setting",
  tableCreate = "tableCreate",
  tableJoin = "tableJoin",
  tableLeave = "tableLeave",
  tableReattend = "tableReattend",
  tableSetLeader = "tableSetLeader",
  tableSetVariant = "tableSetVariant",
  tableTerminate = "tableTerminate",
  tableVoteForTermination = "tableVoteForTermination",
  tableUpdate = "tableUpdate",
}
